export enum ItemError {
  ITEM_NOT_FOUND = "ITEM_NOT_FOUND",
  ITEM_PRICE_MISSING = "ITEM_PRICE_MISSING",
}
